import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { trackAddToCart } from '../lib/metaPixel';
export function BonusSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="offer" ref={ref} className="w-full py-10 md:py-16 bg-gray-50" data-id="element-1">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-3">
          <p className="text-sm text-gray-700 mb-2" data-id="element-4">
            Y para que arranques desde el primer día sin adivinar nada…
          </p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#2D6A4F] mb-1" data-id="element-5">
            Incluyo 1 bono de implementación
          </h2>
          <p className="text-base text-[#40916C] font-medium" data-id="element-6">
            sin costo adicional
          </p>
        </motion.div>

        {/* Bono 1 (formerly Bono 2) */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-2xl border-2 border-[#52B788] overflow-hidden mb-10 shadow-lg" data-id="element-7">
          <div className="flex flex-col md:flex-row" data-id="element-8">
            <div className="md:w-2/5 p-4 flex items-center justify-center bg-gray-900" data-id="element-9">
              <img src="https://cdn.magicpatterns.com/uploads/9gy1Ts7jQ2ob5kigBq98oM/portada_bono_2_calendario.png" alt="Bono 1 - Calendario Piloto Automático" className="w-full max-w-[180px] rounded-lg shadow-md" data-id="element-10" />
            </div>
            <div className="md:w-3/5 p-6" data-id="element-11">
              <div className="flex items-center gap-2 mb-3" data-id="element-12">
                <GiftIcon className="w-5 h-5 text-[#2D6A4F]" data-id="element-13" />
                <Badge className="bg-[#2D6A4F] text-white text-xs" data-id="element-14">
                  BONO #1
                </Badge>
              </div>
              <h3 className="font-heading text-lg font-bold text-[#2D6A4F] mb-1" data-id="element-15">
                Calendario Piloto Automático (30 Días) + Trackers
              </h3>
              <div className="flex items-center gap-2 mb-3" data-id="element-16">
                <span className="text-gray-400 line-through text-xs" data-id="element-17">
                  Valor $13
                </span>
                <Badge variant="outline" className="text-[#40916C] border-[#40916C] text-xs" data-id="element-18">
                  Gratis hoy
                </Badge>
              </div>
              <p className="text-sm text-gray-700 mb-4" data-id="element-19">
                2 minutos al día para saber exactamente qué hacer hasta tu
                primera cosecha.
              </p>
              <ul className="space-y-2" data-id="element-20">
                <li className="flex items-start gap-2" data-id="element-21">
                  <CheckCircle2Icon className="w-4 h-4 text-[#40916C] flex-shrink-0 mt-0.5" data-id="element-22" />
                  <span className="text-sm text-gray-700" data-id="element-23">
                    Micro-tareas diarias (sin adivinar)
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-24">
                  <CheckCircle2Icon className="w-4 h-4 text-[#40916C] flex-shrink-0 mt-0.5" data-id="element-25" />
                  <span className="text-sm text-gray-700" data-id="element-26">
                    Tracker de riego y crecimiento
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-27">
                  <CheckCircle2Icon className="w-4 h-4 text-[#40916C] flex-shrink-0 mt-0.5" data-id="element-28" />
                  <span className="text-sm text-gray-700" data-id="element-29">
                    "Qué hago si…" para los problemas típicos
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Stack de Valor */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-30">
          <h3 id="stack-valor" className="font-heading text-xl md:text-2xl font-bold text-[#2D6A4F] text-center mb-6 scroll-mt-8" data-id="element-31">
            Stack de Valor
          </h3>
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200 mb-6" data-id="element-32">
            <table className="w-full" data-id="element-33">
              <thead data-id="element-34">
                <tr className="bg-[#2D6A4F] text-white" data-id="element-35">
                  <th className="text-left py-3 px-5 font-medium text-sm" data-id="element-36">
                    Incluye
                  </th>
                  <th className="text-right py-3 px-5 font-medium text-sm" data-id="element-37">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-38">
                <tr className="border-b border-gray-100" data-id="element-39">
                  <td className="py-3 px-5 text-sm text-gray-800" data-id="element-40">
                    Huerto en el Balcón (método completo)
                  </td>
                  <td className="py-3 px-5 text-right text-sm text-gray-600" data-id="element-41">
                    $17
                  </td>
                </tr>
                <tr className="border-b border-gray-100 bg-gray-50" data-id="element-42">
                  <td className="py-3 px-5 text-sm text-gray-800" data-id="element-43">
                    <span className="mr-2" data-id="element-44">🎁</span>Bono #1 — Calendario Piloto
                    Automático
                  </td>
                  <td className="py-3 px-5 text-right text-sm text-gray-600" data-id="element-45">
                    $13
                  </td>
                </tr>
                <tr className="bg-[#D8F3DC]" data-id="element-46">
                  <td className="py-4 px-5 font-bold text-[#2D6A4F] text-base" data-id="element-47">
                    Precio hoy
                  </td>
                  <td className="py-4 px-5 text-right" data-id="element-48">
                    <span className="text-gray-400 line-through mr-2 text-sm" data-id="element-49">
                      $30
                    </span>
                    <span className="font-bold text-[#2D6A4F] text-xl" data-id="element-50">
                      $6,39
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="text-center" data-id="element-51">
            <a href="https://www.nachogerberg.com/cart/42672813834311:1" target="_blank" rel="noopener noreferrer" data-id="element-52">
              <Button size="lg" onClick={() => trackAddToCart()} className="bg-[#2D6A4F] hover:bg-[#40916C] text-white text-base px-8 py-5 rounded-full shadow-lg hover:shadow-xl transition-all" data-id="element-53">
                ✅ Quiero mi huerto + el bono →
              </Button>
            </a>
            <p className="text-gray-500 text-xs mt-2" data-id="element-54">
              Acceso inmediato. Descarga directa.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}